"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GisClient = void 0;
const BaseClient_1 = require("../BaseClient");
class GisClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    getArcgisToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/api/v1/gis/arcgisToken',
            });
            return response.data;
        });
    }
    /**
     * The findAddressCandidates operation geocodes one location per request.
     * @param requestParams
     *
     * @see https://developers.arcgis.com/rest/geocode/api-reference/geocoding-find-address-candidates.htm
     *
     * @example findAddressCandidates({ singleLine: '380 New York St, Redlands' });
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    findAddressCandidates(requestParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/api/v1/gis/findAddressCandidates',
                params: requestParams,
            });
            return response.data;
        });
    }
    /**
     * The reverseGeocode operation determines the address at a particular x,y location.
     * @param requestParams
     *
     * @see https://developers.arcgis.com/rest/geocode/api-reference/geocoding-reverse-geocode.htm
     *
     * @example reverseGeocode({ location: '-79.387065,43.642582' });
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reverseGeocode(requestParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/api/v1/gis/reverseGeocode',
                params: requestParams,
            });
            return response.data;
        });
    }
    /**
     * Returns a list of suggestions.
     * @param requestParams
     *
     * @see https://developers.arcgis.com/rest/geocode/api-reference/geocoding-suggest.htm
     *
     * @example suggest({ text: 'New Y' });
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    suggest(requestParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/api/v1/gis/suggest',
                params: requestParams,
            });
            return response.data;
        });
    }
}
exports.GisClient = GisClient;
